import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate, useParams } from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { PROXY_EVENT_LABEL } from "src/constants/labels/proxyEventLabel";
import { PROXY_EVENT_TABS } from "src/constants/tabs";
import { useProxyEventQuery } from "src/store/proxyEvent";
import { isVotingFiling } from "src/utils/proxyEvent/isVotingFiling";

export function ProxyEvent() {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const { data: proxyEvent, isLoading, error } = useProxyEventQuery({ id });
  const match = useMatch(`/proxy-events/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/proxy-events/${id}/${value}`);
  };

  if (error || (!isLoading && !proxyEvent)) {
    return <ErrorState />;
  }

  // Filter out the Voting tab for informational filings
  const tabs =
    proxyEvent && !isVotingFiling(proxyEvent)
      ? PROXY_EVENT_TABS.filter((tab) => tab.value !== "voting")
      : PROXY_EVENT_TABS;

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Proxy Events"
        to={`/proxy-events/${
          proxyEvent?.type && isVotingFiling(proxyEvent)
            ? "voting"
            : "informational"
        }`}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/proxy-events/${id}/details`}
          issuerName={proxyEvent.issuer.name || "-"}
          issuerId={proxyEvent.issuer?.id}
          type={PROXY_EVENT_LABEL[proxyEvent.type]}
          subHeader={
            proxyEvent.jobNumber
              ? `${proxyEvent.solicitor.name} - ${proxyEvent.jobNumber}`
              : proxyEvent.solicitor.name
          }
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={tabs}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
